/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class IsSystemPolicyQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("IsSystemPolicyQueryOperator");
    }

    getFixupPrototypeFunction() { return IsSystemPolicyQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<IsSystemPolicyQueryOperator>): IsSystemPolicyQueryOperator {
        let obj = Object.assign(new IsSystemPolicyQueryOperator(), model);
        IsSystemPolicyQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<IsSystemPolicyQueryOperator>): IsSystemPolicyQueryOperator {
        if (!model) return null;
        return IsSystemPolicyQueryOperator.newInstance(<IsSystemPolicyQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: IsSystemPolicyQueryOperator) {
        if (!obj) return;

        models.IsSystemPolicyQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: IsSystemPolicyQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, IsSystemPolicyQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Is system policy to include
     */
    is_system_policy: boolean;

}
